// Author Eric
// Date 2024-09-05 17:08:07

class SithMesPrdLearning {
    constructor({
                    id = null,
                    realName = '',
                    name = '',
                    version = '',
                    suffix = '',
                    path = '',
                    type = '',
                    size = '',
                    locationId = '',
                    learningTypeId = '',
                    remark = ''
                }
                        = {}) {
        this.id = id;
        this.realName = realName;
        this.name = name;
        this.version = version;
        this.suffix = suffix;
        this.path = path;
        this.type = type;
        this.size = size;
        this.locationId = locationId;
        this.learningTypeId = learningTypeId;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesPrdLearning();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'locationName',
            label: 'label.sith.prd.sithMesPrdLearning.grid.locationName',
            sortable: true,
            form: {
                type: 'input',
            }
        },
        {
            key: 'name',
            label: 'label.sith.prd.sithMesPrdLearning.grid.name',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'version',
            label: 'label.sith.prd.sithMesPrdLearning.grid.version',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'suffix',
            label: 'label.sith.prd.sithMesPrdLearning.grid.suffix',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'size',
            label: 'label.sith.prd.sithMesPrdLearning.grid.size',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.prd.sithMesPrdLearning.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdByName',
            label: 'label.sith.prd.sithMesPrdLearning.grid.createdByName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdTime',
            label: 'label.sith.prd.sithMesPrdLearning.grid.createdTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'learningType',
            label: 'label.sith.prd.sithMesPrdLearning.grid.learningType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    locationIdFilter: '',
    realNameFilter: '',
    nameFilter: '',
    suffixFilter: '',
    pathFilter: '',
    typeFilter: '',
    sizeFilter: '',
    learningTypeIdFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'locationIdFilter',
        label: 'label.sith.prd.sithMesPrdLearning.filter.locationId',
        disabled: false,
        form: {
            type: 'entitySelect'
            , entity: 'sithMesMstLocation'
            , showLabelSelectOne: true
            , selectFilter: {'parentIdFilter': '20313'}
        }
    },
    {
        key: 'nameFilter',
        label: 'label.sith.prd.sithMesPrdLearning.filter.name',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'suffixFilter',
        label: 'label.sith.prd.sithMesPrdLearning.filter.suffix',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sizeFilter',
        label: 'label.sith.prd.sithMesPrdLearning.filter.size',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'learningTypeIdFilter',
        label: 'label.sith.prd.sithMesPrdLearning.filter.learningTypeId',
        disabled: false,
        form: {
            type: 'dictEnumSelect',
            modalMultiSelectedType: 'string'
            , entity: 'learning_type'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdLearning.entity.name',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'version',
        label: 'label.sith.prd.sithMesPrdLearning.entity.version',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'suffix',
        label: 'label.sith.prd.sithMesPrdLearning.entity.suffix',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'size',
        label: 'label.sith.prd.sithMesPrdLearning.entity.size',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'locationId',
        label: 'label.sith.prd.sithMesPrdLearning.entity.locationId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entitySelect'
            , entity: 'sithMesMstLocation'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'learningTypeId',
        label: 'label.sith.prd.sithMesPrdLearning.entity.learningTypeId',
        sortable: true,
        disabled: false,
        form: {
            type: 'dictEnumSelect',
            modalMultiSelectedType: 'string'
            , entity: 'learning_type'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdLearning.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesPrdLearning, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
